import getSettingDepositAndWithdraw from "@/services/payment/getSettingDepositAndWithdraw";
import React, { useEffect, useState } from "react";

function useGetSettingDepositAndWithdraw() {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<any>();
    const [error, setError] = useState<any>();
    useEffect(() => {
        setLoading(true);
        getSettingDepositAndWithdraw(
            (responseData) => {
                setData(responseData);
                setLoading(false);
            },
            (err) => {
                setError(err);
                setLoading(false);
            }
        );
    }, []);
    return {
        loading,
        data,
        error,
    };
}

export default useGetSettingDepositAndWithdraw;
